module.exports = "https://web-assets.ifttt.com/packs/media/prosumer/image--business-circle-6-a04b5739.png";